// Only download static page code on intent. Never prefetch tracked event GETs,
// inventory, carts or quotes. A failed speculative load remains retryable.
let eventModule;
export const loadEventPage = () => {
  if (!eventModule) {
    eventModule = import('../pages/EventDetails').catch(error => {
      if (error?.name === 'ChunkLoadError' || /Loading (?:CSS )?chunk/.test(error?.message || '')) {
        return import('../pages/EventDetails');
      }
      throw error;
    }).catch(error => {
      eventModule = null;
      throw error;
    });
  }
  return eventModule;
};
export const preloadEventPage = () => {
  if (navigator.connection?.saveData) return;
  loadEventPage().catch(() => {});
};
